<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="TIPO DE PUERTA" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <b-row class="mb-2">
            <b-form-group class="w-100">
              <template #label>
                <Label label="Tipo de puerta" :blank="form.door_type" show-reset @reset="form.door_type = null" />
              </template>
              <b-select v-model="form.door_type" :options="doorTypeOptions">
                <template #first>
                  <b-select-option v-show="!form.door_type" :value="null">
                    -- seleccionar --
                  </b-select-option>
                </template>
              </b-select>
            </b-form-group>
          </b-row>

          <b-row v-if="form.door_type === 'Puerta Corrediza'" align-h="center" class="mb-2">
            <div class="door-type-img-container">
              <img
                v-if="form.door_configuration"
                :src="doorConfigurationImg"
                alt="door-type-img"
              >
              <p v-else class="text-muted fs-18">Seleccione una configuración para la puerta</p>
            </div>
          </b-row>

          <b-row v-if="form.door_type === 'Puerta Corrediza'">
            <b-form-group class="w-100">
              <template #label>
                <Label
                  label="Configuración de puerta"
                  :alert-msg="configAlertMsg"
                  :blank="form.door_configuration"
                  show-reset
                  @reset="form.door_configuration = null"
                />
              </template>
              <b-select
                v-model="form.door_configuration"
                :options="configurationOptions"
                :disabled="configAlertMsg"
              >
                <template #first>
                  <b-select-option v-show="!form.door_configuration" :value="null">
                    -- seleccionar --
                  </b-select-option>
                </template>
              </b-select>
            </b-form-group>
          </b-row>

          <StepNotes
            :value="form.door_type_notes"
            @update-form="updateStepNotes"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import StepNotes from '../StepNotes'
import Label from '../Label'
import MissingImage from '../../../../../../public/images/original/missing.png'
import {
  doorTypeOptions,
  doorConfigurationOptions
} from '../../../../sharedOptions/puertasAutomaticasModule'

const configurationImages = require.context(
  'images/puerta_automatica/configurations',
  false,
  /\.png$/
)

export default {
  name: 'DoorType',
  components: { Label, ConfiguratorStepTitle, StepNotes },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        door_type: null,
        door_configuration: null,
        door_type_notes: ''
      },
      doorTypeOptions,
      doorConfigurationOptions,
      missingImg: MissingImage
    }
  },
  mounted () {
    if (!this.puerta) return

    this.form = {
      door_type: this.puerta.door_type ?? null,
      door_configuration: this.puerta.leaf_material
        ? this.puerta.door_configuration
        : null,
      door_type_notes: this.puerta.door_type_notes ?? ''
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable
    }),
    ...mapGetters(['configuratorStepNumber']),
    configAlertMsg () {
      const p = this.puerta || {}
      const { fabrication_type, leaf_material } = p
      if (!fabrication_type) return 'Debe seleccionar primero el tipo de fabricación en general'
      if (!leaf_material) return 'Debe seleccionar primero el material de la hoja en general'

      return null
    },
    configurationOptions () {
      const p = this.puerta || {}
      const { fabrication_type, leaf_material } = p

      if (!fabrication_type || !leaf_material) return []
      if (this.form.door_type !== 'Puerta Corrediza') return []

      let options = this.doorConfigurationOptions

      if (fabrication_type === 'Nacional') {
        options = options.filter(o => o.type.includes(leaf_material))
      }

      return options.map(o => ({ text: o.text, value: o.value }))
    },
    doorConfigurationImg() {
      const { door_type, door_configuration } = this.form
      const leaf_material = this.puerta.leaf_material
      const fabrication_type = this.puerta.fabrication_type

      if (!door_type || !door_configuration || !leaf_material || !fabrication_type) {
        return this.missingImg
      }

      let prefix = ''
      if (leaf_material === 'Solo vidrio') {
        prefix = 'SV_'
      } else if (leaf_material === 'Zocalo de aluminio') {
        prefix = 'ZOC_'
      }

      const filename = `${prefix}${door_configuration}.png`

      try {
        return configurationImages('./' + filename)
      } catch {
        return this.missingImg
      }
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.puerta[key])
    },
    updateStepNotes (notes) {
      this.form.door_type_notes = notes
    }
  }
}
</script>

<style scoped lang="scss">
  .door-type-img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 430px;
    height: 270px;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
</style>